<template>
  <div class="management-page-outer-container">
    <router-view />
    <div
      v-if="$route.name === 'client-roles'"
      class="data-table management-main-list-data-table"
    >
      <role-list
        :pagination-from-parent="pagination"
        @update-pagination="pagination = $event"
        :search-from-parent="search"
        @update-search="search = $event"
      >
        <management-add-button
          v-if="isSuperAdmin || isAdmin"
          :label="$t('AddRole')"
          @buttonClick="$router.push({ name: 'client-role-create' })"
          :disabled="!hasNeededPermissionsTo(addButtonMissingPermissions)"
          :list-missing-permissions="addButtonMissingPermissions"
        />
        <div v-else style="height: 90px;"></div>
      </role-list>
    </div>
  </div>
</template>

<script>
import RoleList from "@/components/SystemManagement/Accounts/ClientRoles/ClientRoleList";
import ManagementAddButton from "@/components/Management/ManagementAddButton";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
export default {
  name: "Role",

  components: { ManagementAddButton, RoleList },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      /**
       * Stores all information regarding the pagination of the table (page number| number of items| sort)
       */
      pagination: null,
      /**
       * Save the value of the last search
       */
      search: ""
    };
  },

  computed: {
    /**
     * Returns the missing permissions to create a client role
     * @return {[]}
     */
    addButtonMissingPermissions() {
      let neededPermissions = ["client_role_store"];
      return this.getMissingPermissionsList(neededPermissions);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/Accounts/ClientRoles/ClientRole.vue